import type { HotelBookingRoomOption } from "@/features/hotels/types/types";

export function isRefundable(roomOffer: HotelBookingRoomOption): boolean {
  return !roomOffer.tags.includes("Non-refundable");
}
